import React from "react";
import "./index.css";
function Footer(){
    return(
        <footer>
        <div className="container">
            <div className="row">
                <div className="col-md-3">
                    <a href="#">
                        <img src={process.env.PUBLIC_URL + "/img/bedater-logo.png"} alt="" title="" width="62" />
                    </a>
                    <p>Copyright &copy; 2021, Bedater All Rights Reserved.</p>
                    <div className="social">
                        <h3>Follow us</h3>
                        <a href="" target="_blank">
                            <img src={process.env.PUBLIC_URL + "/img/instagram-icon.png"} width="24" alt="" title="" />
                        </a>
                        <a href="#" target="_blank">
                            <img src={process.env.PUBLIC_URL + "/img/twitter-icon.png"} width="24" alt="" title="" />
                        </a>
                        <a href="#" target="_blank">
                            <img src={process.env.PUBLIC_URL + "/img/facebook-icon.png"} width="24" alt="" title="" />
                        </a>
                    </div>
                </div>
                <div className="col-md-3">
                    <h3>About</h3>
                    <ul>
                        <li>
                            <a href="#">Company</a>
                        </li>
                        <li>
                            <a href="#">Leadership</a>
                        </li>
                        <li>
                            <a href="#">Careers</a>
                        </li>
                        <li>
                            <a href="#">Open positions</a>
                        </li>
                        <li>
                            <a href="#">Press</a>
                        </li>
                        <li>
                            <a href="#">Investor relations</a>
                        </li>
                        <li>
                            <a href="#">Contact us</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-3">
                    <h3>Other Links</h3>
                    <ul>
                        <li>
                            <a href="#">Company</a>
                        </li>
                        <li>
                            <a href="#">Leadership</a>
                        </li>
                        <li>
                            <a href="#">Careers</a>
                        </li>
                        <li>
                            <a href="#">Open positions</a>
                        </li>
                        <li>
                            <a href="#">Press</a>
                        </li>
                        <li>
                            <a href="#">Investor relations</a>
                        </li>
                        <li>
                            <a href="#">Contact us</a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-3">
                    <h3>Terms and conditions</h3>
                    <ul>
                        <li>
                            <a href="#">Terms and Conditions</a>
                        </li>
                        <li>
                            <a href="#">Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#">Student Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#">Inclusion and Accessibility policy</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    );
}

export default Footer;